// extracted by mini-css-extract-plugin
export default {"collapse":"collapse--ybUEV","collapseContainer":"collapseContainer--CZzhM","collapseWrapperInner":"collapseWrapperInner--Urlte","mobileVert":"mobileVert--nI2ax"};